module.exports = __webpack_public_path__ + "06_bob_brown.3bc97434.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_bob_brown.png
// module id = 427k
// module chunks = 0